/**
 * Country values used to fill select field in Vendor Applicaton
 */

const CountryList = [
  { value: 'US', text: 'United States', alpha3: 'USA' },
  { value: 'AF', text: 'Afghanistan', alpha3: 'AFG' },
  { value: 'AX', text: 'Åland Islands', alpha3: 'ALA' },
  { value: 'AL', text: 'Albania', alpha3: 'ALB' },
  { value: 'DZ', text: 'Algeria', alpha3: 'DZA' },
  { value: 'AS', text: 'American Samoa', alpha3: 'ASM' },
  { value: 'AD', text: 'Andorra', alpha3: 'AND' },
  { value: 'AO', text: 'Angola', alpha3: 'AGO' },
  { value: 'AI', text: 'Anguilla', alpha3: 'AIA' },
  { value: 'AQ', text: 'Antarctica', alpha3: 'ATA' },
  { value: 'AG', text: 'Antigua and Barbuda', alpha3: 'ATG' },
  { value: 'AR', text: 'Argentina', alpha3: 'ARG' },
  { value: 'AM', text: 'Armenia', alpha3: 'ARM' },
  { value: 'AW', text: 'Aruba', alpha3: 'ABW' },
  { value: 'AU', text: 'Australia', alpha3: 'AUS' },
  { value: 'AT', text: 'Austria', alpha3: 'AUT' },
  { value: 'AZ', text: 'Azerbaijan', alpha3: 'AZE' },
  { value: 'BS', text: 'Bahamas', alpha3: 'BHS' },
  { value: 'BH', text: 'Bahrain', alpha3: 'BHR' },
  { value: 'BD', text: 'Bangladesh', alpha3: 'BGD' },
  { value: 'BB', text: 'Barbados', alpha3: 'BRB' },
  { value: 'BY', text: 'Belarus', alpha3: 'BLR' },
  { value: 'BE', text: 'Belgium', alpha3: 'BEL' },
  { value: 'BZ', text: 'Belize', alpha3: 'BLZ' },
  { value: 'BJ', text: 'Benin', alpha3: 'BEN' },
  { value: 'BM', text: 'Bermuda', alpha3: 'BMU' },
  { value: 'BT', text: 'Bhutan', alpha3: 'BTN' },
  { value: 'BO', text: 'Bolivia (Plurinational State of)', alpha3: 'BOL' },
  { value: 'BQ', text: 'Bonaire, Sint Eustatius and Saba', alpha3: 'BES' },
  { value: 'BA', text: 'Bosnia and Herzegovina', alpha3: 'BIH' },
  { value: 'BW', text: 'Botswana', alpha3: 'BWA' },
  { value: 'BV', text: 'Bouvet Island', alpha3: 'BVT' },
  { value: 'BR', text: 'Brazil', alpha3: 'BRA' },
  { value: 'IO', text: 'British Indian Ocean Territory', alpha3: 'IOT' },
  { value: 'BN', text: 'Brunei Darussalam', alpha3: 'BRN' },
  { value: 'BG', text: 'Bulgaria', alpha3: 'BGR' },
  { value: 'BF', text: 'Burkina Faso', alpha3: 'BFA' },
  { value: 'BI', text: 'Burundi', alpha3: 'BDI' },
  { value: 'KH', text: 'Cambodia', alpha3: 'KHM' },
  { value: 'CM', text: 'Cameroon', alpha3: 'CMR' },
  { value: 'CA', text: 'Canada', alpha3: 'CAN' },
  { value: 'IC', text: 'Canary Islands', alpha3: null },
  { value: 'CV', text: 'Cabo Verde', alpha3: 'CPV' },
  { value: 'KY', text: 'Cayman Islands', alpha3: 'CYM' },
  { value: 'CF', text: 'Central African Republic', alpha3: 'CAF' },
  { value: 'EA', text: 'Ceuta and Melilla', alpha3: null },
  { value: 'TD', text: 'Chad', alpha3: 'TCD' },
  { value: 'CL', text: 'Chile', alpha3: 'CHL' },
  { value: 'CN', text: 'China', alpha3: 'CHN' },
  { value: 'CX', text: 'Christmas Island', alpha3: 'CXR' },
  { value: 'CC', text: 'Cocos (Keeling) Islands', alpha3: 'CCK' },
  { value: 'CO', text: 'Colombia', alpha3: 'COL' },
  { value: 'KM', text: 'Comoros', alpha3: 'COM' },
  {
    value: 'CD',
    text: 'Congo (the Democratic Republic of the)',
    alpha3: 'COD',
  },
  { value: 'CG', text: 'Congo', alpha3: 'COG' },
  { value: 'CK', text: 'Cook Islands', alpha3: 'COK' },
  { value: 'CR', text: 'Costa Rica', alpha3: 'CRI' },
  { value: 'CI', text: "Côte d'Ivoire", alpha3: 'CIV' },
  { value: 'HR', text: 'Croatia', alpha3: 'HRV' },
  { value: 'CU', text: 'Cuba', alpha3: 'CUB' },
  { value: 'CW', text: 'Curaçao', alpha3: 'CUW' },
  { value: 'CY', text: 'Cyprus', alpha3: 'CYP' },
  { value: 'CZ', text: 'Czechia', alpha3: 'CZE' },
  { value: 'DK', text: 'Denmark', alpha3: 'DNK' },
  { value: 'DJ', text: 'Djibouti', alpha3: 'DJI' },
  { value: 'DM', text: 'Dominica', alpha3: 'DMA' },
  { value: 'DO', text: 'Dominican Republic', alpha3: 'DOM' },
  { value: 'TL', text: 'Timor-Leste', alpha3: 'TLS' },
  { value: 'EC', text: 'Ecuador', alpha3: 'ECU' },
  { value: 'EG', text: 'Egypt', alpha3: 'EGY' },
  { value: 'SV', text: 'El Salvador', alpha3: 'SLV' },
  { value: 'GQ', text: 'Equatorial Guinea', alpha3: 'GNQ' },
  { value: 'ER', text: 'Eritrea', alpha3: 'ERI' },
  { value: 'EE', text: 'Estonia', alpha3: 'EST' },
  { value: 'ET', text: 'Ethiopia', alpha3: 'ETH' },
  { value: 'FK', text: 'Falkland Islands (Malvinas)', alpha3: 'FLK' },
  { value: 'FO', text: 'Faroe Islands', alpha3: 'FRO' },
  { value: 'FJ', text: 'Fiji', alpha3: 'FJI' },
  { value: 'FI', text: 'Finland', alpha3: 'FIN' },
  { value: 'FR', text: 'France', alpha3: 'FRA' },
  { value: 'GF', text: 'French Guiana', alpha3: 'GUF' },
  { value: 'PF', text: 'French Polynesia', alpha3: 'PYF' },
  { value: 'TF', text: 'French Southern Territories', alpha3: 'ATF' },
  { value: 'GA', text: 'Gabon', alpha3: 'GAB' },
  { value: 'GM', text: 'Gambia', alpha3: 'GMB' },
  { value: 'GE', text: 'Georgia', alpha3: 'GEO' },
  { value: 'DE', text: 'Germany', alpha3: 'DEU' },
  { value: 'GH', text: 'Ghana', alpha3: 'GHA' },
  { value: 'GI', text: 'Gibraltar', alpha3: 'GIB' },
  { value: 'GR', text: 'Greece', alpha3: 'GRC' },
  { value: 'GL', text: 'Greenland', alpha3: 'GRL' },
  { value: 'GD', text: 'Grenada', alpha3: 'GRD' },
  { value: 'GP', text: 'Guadeloupe', alpha3: 'GLP' },
  { value: 'GU', text: 'Guam', alpha3: 'GUM' },
  { value: 'GT', text: 'Guatemala', alpha3: 'GTM' },
  { value: 'GG', text: 'Guernsey', alpha3: 'GGY' },
  { value: 'GN', text: 'Guinea', alpha3: 'GIN' },
  { value: 'GW', text: 'Guinea-Bissau', alpha3: 'GNB' },
  { value: 'GY', text: 'Guyana', alpha3: 'GUY' },
  { value: 'HT', text: 'Haiti', alpha3: 'HTI' },
  { value: 'HM', text: 'Heard Island and McDonald Islands', alpha3: 'HMD' },
  { value: 'VA', text: 'Holy See', alpha3: 'VAT' },
  { value: 'HN', text: 'Honduras', alpha3: 'HND' },
  { value: 'HK', text: 'Hong Kong', alpha3: 'HKG' },
  { value: 'HU', text: 'Hungary', alpha3: 'HUN' },
  { value: 'IS', text: 'Iceland', alpha3: 'ISL' },
  { value: 'IN', text: 'India', alpha3: 'IND' },
  { value: 'ID', text: 'Indonesia', alpha3: 'IDN' },
  { value: 'IR', text: 'Iran (Islamic Republic of)', alpha3: 'IRN' },
  { value: 'IQ', text: 'Iraq', alpha3: 'IRQ' },
  { value: 'IE', text: 'Ireland', alpha3: 'IRL' },
  { value: 'IM', text: 'Isle of Man', alpha3: 'IMN' },
  { value: 'IL', text: 'Israel', alpha3: 'ISR' },
  { value: 'IT', text: 'Italy', alpha3: 'ITA' },
  { value: 'JM', text: 'Jamaica', alpha3: 'JAM' },
  { value: 'JP', text: 'Japan', alpha3: 'JPN' },
  { value: 'JE', text: 'Jersey', alpha3: 'JEY' },
  { value: 'JO', text: 'Jordan', alpha3: 'JOR' },
  { value: 'KZ', text: 'Kazakhstan', alpha3: 'KAZ' },
  { value: 'KE', text: 'Kenya', alpha3: 'KEN' },
  { value: 'KI', text: 'Kiribati', alpha3: 'KIR' },
  {
    value: 'KP',
    text: "Korea (the Democratic People's Republic of)",
    alpha3: 'PRK',
  },
  { value: 'KR', text: 'Korea (the Republic of)', alpha3: 'KOR' },
  { value: 'XK', text: 'Kosovo', alpha3: 'XXK' },
  { value: 'KW', text: 'Kuwait', alpha3: 'KWT' },
  { value: 'KG', text: 'Kyrgyzstan', alpha3: 'KGZ' },
  { value: 'LA', text: "Lao People's Democratic Republic", alpha3: 'LAO' },
  { value: 'LV', text: 'Latvia', alpha3: 'LVA' },
  { value: 'LB', text: 'Lebanon', alpha3: 'LBN' },
  { value: 'LS', text: 'Lesotho', alpha3: 'LSO' },
  { value: 'LR', text: 'Liberia', alpha3: 'LBR' },
  { value: 'LY', text: 'Libya', alpha3: 'LBY' },
  { value: 'LI', text: 'Liechtenstein', alpha3: 'LIE' },
  { value: 'LT', text: 'Lithuania', alpha3: 'LTU' },
  { value: 'LU', text: 'Luxembourg', alpha3: 'LUX' },
  { value: 'MO', text: 'Macao', alpha3: 'MAC' },
  { value: 'MK', text: 'North Macedonia', alpha3: 'MKD' },
  { value: 'MG', text: 'Madagascar', alpha3: 'MDG' },
  { value: 'MW', text: 'Malawi', alpha3: 'MWI' },
  { value: 'MY', text: 'Malaysia', alpha3: 'MYS' },
  { value: 'MV', text: 'Maldives', alpha3: 'MDV' },
  { value: 'ML', text: 'Mali', alpha3: 'MLI' },
  { value: 'MT', text: 'Malta', alpha3: 'MLT' },
  { value: 'MH', text: 'Marshall Islands', alpha3: 'MHL' },
  { value: 'MQ', text: 'Martinique', alpha3: 'MTQ' },
  { value: 'MR', text: 'Mauritania', alpha3: 'MRT' },
  { value: 'MU', text: 'Mauritius', alpha3: 'MUS' },
  { value: 'YT', text: 'Mayotte', alpha3: 'MYT' },
  { value: 'MX', text: 'Mexico', alpha3: 'MEX' },
  { value: 'FM', text: 'Micronesia (Federated States of)', alpha3: 'FSM' },
  { value: 'MD', text: 'Moldova (the Republic of)', alpha3: 'MDA' },
  { value: 'MC', text: 'Monaco', alpha3: 'MCO' },
  { value: 'MN', text: 'Mongolia', alpha3: 'MNG' },
  { value: 'ME', text: 'Montenegro', alpha3: 'MNE' },
  { value: 'MS', text: 'Montserrat', alpha3: 'MSR' },
  { value: 'MA', text: 'Morocco', alpha3: 'MAR' },
  { value: 'MZ', text: 'Mozambique', alpha3: 'MOZ' },
  { value: 'MM', text: 'Myanmar', alpha3: 'MMR' },
  { value: 'NA', text: 'Namibia', alpha3: 'NAM' },
  { value: 'NR', text: 'Nauru', alpha3: 'NRU' },
  { value: 'NP', text: 'Nepal', alpha3: 'NPL' },
  { value: 'NL', text: 'Netherlands', alpha3: 'NLD' },
  { value: 'AN', text: 'Netherlands Antilles (Deprecated)', alpha3: 'ANT' },
  { value: 'NC', text: 'New Caledonia', alpha3: 'NCL' },
  { value: 'NZ', text: 'New Zealand', alpha3: 'NZL' },
  { value: 'NI', text: 'Nicaragua', alpha3: 'NIC' },
  { value: 'NE', text: 'Niger', alpha3: 'NER' },
  { value: 'NG', text: 'Nigeria', alpha3: 'NGA' },
  { value: 'NU', text: 'Niue', alpha3: 'NIU' },
  { value: 'NF', text: 'Norfolk Island', alpha3: 'NFK' },
  { value: 'MP', text: 'Northern Mariana Islands', alpha3: 'MNP' },
  { value: 'NO', text: 'Norway', alpha3: 'NOR' },
  { value: 'OM', text: 'Oman', alpha3: 'OMN' },
  { value: 'PK', text: 'Pakistan', alpha3: 'PAK' },
  { value: 'PW', text: 'Palau', alpha3: 'PLW' },
  { value: 'PS', text: 'Palestine, State of', alpha3: 'PSE' },
  { value: 'PA', text: 'Panama', alpha3: 'PAN' },
  { value: 'PG', text: 'Papua New Guinea', alpha3: 'PNG' },
  { value: 'PY', text: 'Paraguay', alpha3: 'PRY' },
  { value: 'PE', text: 'Peru', alpha3: 'PER' },
  { value: 'PH', text: 'Philippines', alpha3: 'PHL' },
  { value: 'PN', text: 'Pitcairn', alpha3: 'PCN' },
  { value: 'PL', text: 'Poland', alpha3: 'POL' },
  { value: 'PT', text: 'Portugal', alpha3: 'PRT' },
  { value: 'PR', text: 'Puerto Rico', alpha3: 'PRI' },
  { value: 'QA', text: 'Qatar', alpha3: 'QAT' },
  { value: 'RE', text: 'Réunion', alpha3: 'REU' },
  { value: 'RO', text: 'Romania', alpha3: 'ROU' },
  { value: 'RU', text: 'Russian Federation', alpha3: 'RUS' },
  { value: 'RW', text: 'Rwanda', alpha3: 'RWA' },
  { value: 'BL', text: 'Saint Barthélemy', alpha3: 'BLM' },
  {
    value: 'SH',
    text: 'Saint Helena, Ascension and Tristan da Cunha',
    alpha3: 'SHN',
  },
  { value: 'KN', text: 'Saint Kitts and Nevis', alpha3: 'KNA' },
  { value: 'LC', text: 'Saint Lucia', alpha3: 'LCA' },
  { value: 'MF', text: 'Saint Martin (French part)', alpha3: 'MAF' },
  { value: 'VC', text: 'Saint Vincent and the Grenadines', alpha3: 'VCT' },
  { value: 'WS', text: 'Samoa', alpha3: 'WSM' },
  { value: 'SM', text: 'San Marino', alpha3: 'SMR' },
  { value: 'ST', text: 'Sao Tome and Principe', alpha3: 'STP' },
  { value: 'SA', text: 'Saudi Arabia', alpha3: 'SAU' },
  { value: 'SN', text: 'Senegal', alpha3: 'SEN' },
  { value: 'RS', text: 'Serbia', alpha3: 'SRB' },
  { value: 'CS', text: 'Serbia and Montenegro (Deprecated)', alpha3: null },
  { value: 'SC', text: 'Seychelles', alpha3: 'SYC' },
  { value: 'SL', text: 'Sierra Leone', alpha3: 'SLE' },
  { value: 'SG', text: 'Singapore', alpha3: 'SGP' },
  { value: 'SX', text: 'Sint Maarten (Dutch part)', alpha3: 'SXM' },
  { value: 'SK', text: 'Slovakia', alpha3: 'SVK' },
  { value: 'SI', text: 'Slovenia', alpha3: 'SVN' },
  { value: 'SB', text: 'Solomon Islands', alpha3: 'SLB' },
  { value: 'SO', text: 'Somalia', alpha3: 'SOM' },
  { value: 'ZA', text: 'South Africa', alpha3: 'ZAF' },
  {
    value: 'GS',
    text: 'South Georgia and the South Sandwich Islands',
    alpha3: 'SGS',
  },
  { value: 'SS', text: 'South Sudan', alpha3: 'SSD' },
  { value: 'ES', text: 'Spain', alpha3: 'ESP' },
  { value: 'LK', text: 'Sri Lanka', alpha3: 'LKA' },
  { value: 'PM', text: 'Saint Pierre and Miquelon', alpha3: 'SPM' },
  { value: 'SD', text: 'Sudan', alpha3: 'SDN' },
  { value: 'SR', text: 'Suriname', alpha3: 'SUR' },
  { value: 'SJ', text: 'Svalbard and Jan Mayen', alpha3: 'SJM' },
  { value: 'SZ', text: 'Eswatini', alpha3: 'SWZ' },
  { value: 'SE', text: 'Sweden', alpha3: 'SWE' },
  { value: 'CH', text: 'Switzerland', alpha3: 'CHE' },
  { value: 'SY', text: 'Syrian Arab Republic', alpha3: 'SYR' },
  { value: 'TW', text: 'Taiwan (Province of China)', alpha3: 'TWN' },
  { value: 'TJ', text: 'Tajikistan', alpha3: 'TJK' },
  { value: 'TZ', text: 'Tanzania, the United Republic of', alpha3: 'TZA' },
  { value: 'TH', text: 'Thailand', alpha3: 'THA' },
  { value: 'TG', text: 'Togo', alpha3: 'TGO' },
  { value: 'TK', text: 'Tokelau', alpha3: 'TKL' },
  { value: 'TO', text: 'Tonga', alpha3: 'TON' },
  { value: 'TT', text: 'Trinidad and Tobago', alpha3: 'TTO' },
  { value: 'TN', text: 'Tunisia', alpha3: 'TUN' },
  { value: 'TR', text: 'Türkiye', alpha3: 'TUR' },
  { value: 'TM', text: 'Turkmenistan', alpha3: 'TKM' },
  { value: 'TC', text: 'Turks and Caicos Islands', alpha3: 'TCA' },
  { value: 'TV', text: 'Tuvalu', alpha3: 'TUV' },
  { value: 'UG', text: 'Uganda', alpha3: 'UGA' },
  { value: 'UA', text: 'Ukraine', alpha3: 'UKR' },
  { value: 'AE', text: 'United Arab Emirates', alpha3: 'ARE' },
  { value: 'GB', text: 'United Kingdom', alpha3: 'GBR' },
  { value: 'UY', text: 'Uruguay', alpha3: 'URY' },
  { value: 'UM', text: 'United States Minor Outlying Islands', alpha3: 'UMI' },
  { value: 'UZ', text: 'Uzbekistan', alpha3: 'UZB' },
  { value: 'VU', text: 'Vanuatu', alpha3: 'VUT' },
  { value: 'VE', text: 'Venezuela (Bolivarian Republic of)', alpha3: 'VEN' },
  { value: 'VN', text: 'Viet Nam', alpha3: 'VNM' },
  { value: 'VG', text: 'Virgin Islands (British)', alpha3: 'VGB' },
  { value: 'VI', text: 'Virgin Islands (U.S.)', alpha3: 'VIR' },
  { value: 'WF', text: 'Wallis and Futuna', alpha3: 'WLF' },
  { value: 'EH', text: 'Western Sahara', alpha3: 'ESH' },
  { value: 'YE', text: 'Yemen', alpha3: 'YEM' },
  { value: 'ZM', text: 'Zambia', alpha3: 'ZMB' },
  { value: 'ZW', text: 'Zimbabwe', alpha3: 'ZWE' },
];

export const CountryListSelectInputOptions = [
  { value: 'US', label: 'United States' },
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AX', label: 'Åland Islands' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia (Plurinational State of)' },
  { value: 'BQ', label: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Island' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'British Indian Ocean Territory' },
  { value: 'BN', label: 'Brunei Darussalam' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'IC', label: 'Canary Islands' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'EA', label: 'Ceuta and Melilla' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'CC', label: 'Cocos (Keeling) Islands' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CD', label: 'Congo (the Democratic Republic of the)' },
  { value: 'CG', label: 'Congo' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CI', label: "Côte d'Ivoire" },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curaçao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czechia' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FK', label: 'Falkland Islands (Malvinas)' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'TF', label: 'French Southern Territories' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard Island and McDonald Islands' },
  { value: 'VA', label: 'Holy See' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran (Islamic Republic of)' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IM', label: 'Isle of Man' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KP', label: "Korea (the Democratic People's Republic of)" },
  { value: 'KR', label: 'Korea (the Republic of)' },
  { value: 'XK', label: 'Kosovo' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: "Lao People's Democratic Republic" },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macao' },
  { value: 'MK', label: 'North Macedonia' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia (Federated States of)' },
  { value: 'MD', label: 'Moldova (the Republic of)' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'AN', label: 'Netherlands Antilles (Deprecated)' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Island' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine, State of' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PN', label: 'Pitcairn' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RE', label: 'Réunion' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russian Federation' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'BL', label: 'Saint Barthélemy' },
  {
    value: 'SH',
    label: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'MF', label: 'Saint Martin (French part)' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'CS', label: 'Serbia and Montenegro (Deprecated)' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Maarten (Dutch part)' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  {
    value: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
  },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'PM', label: 'Saint Pierre and Miquelon' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syrian Arab Republic' },
  { value: 'TW', label: 'Taiwan (Province of China)' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania, the United Republic of' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Türkiye' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks and Caicos Islands' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UM', label: 'United States Minor Outlying Islands' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela (Bolivarian Republic of)' },
  { value: 'VN', label: 'Viet Nam' },
  { value: 'VG', label: 'Virgin Islands (British)' },
  { value: 'VI', label: 'Virgin Islands (U.S.)' },
  { value: 'WF', label: 'Wallis and Futuna' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' },
];

export default CountryList;
